import React from 'react';
import { ColumnsType } from 'antd/lib/table';
import { getI18n } from 'react-i18next';
import TableHeader from '~/pages/agent/components/agent/tableElements/TableHeader';
import { CellText } from '~/pages/agent/components/agent/tableElements/cells/CellText';

function companyNameCell(visibleColumns: any) {
  if (!visibleColumns.includes('companyName')) {
    return null;
  }
  return {
    title: <TableHeader title={getI18n().t('Company Name', { ns: 'sales' })} />,
    dataIndex: ['companyName'],
    key: 'companyName',
    render: (companyName: any) => <CellText>{companyName}</CellText>,
    width: 180,
  };
}

export default companyNameCell;
